var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V8H20C20.5523 8 21 8.44772 21 9V15C21 15.5523 20.5523 16 20 16H16V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V16H4C3.44772 16 3 15.5523 3 15V9C3 8.44771 3.44772 8 4 8H8ZM10 5H14V10H19V14H14V19H10V14H5L5 10H10V5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8a5c86e670a5109637c20800810bd69d.svg";
export { ForwardRef as ReactComponent };